import simg from '../images/practice/img-2.jpg'
import simg2 from '../images/practice/img-1.jpg'
import simg3 from '../images/practice/img-3.jpg'
import simg4 from '../images/practice/img-4.jpg'
import simg5 from '../images/practice/img-5.jpg'
import simg6 from '../images/practice/img-6.jpg'
import simg7 from '../images/practice/img-6.jpg'
import simg8 from '../images/practice/img-6.jpg'

import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'

const Practices = [
  {
    Id: '1',
    simg: simg,
    sTitle: 'Commercial & Corporate Advisory',
    slug: 'Commercial-Corporate-Advisory',
    description:'Comprehensive business formation, restructuring, M&A, shareholder agreements, and regulatory compliance services for corporates and SMEs.',
    des2:'Expert corporate governance, compliance frameworks, and strategic commercial advisory.',
    des3:'We provide end-to-end corporate advisory including business formation, contract drafting, regulatory compliance, investment advisory, and company secretarial services.',
    icon:'flaticon-013-planning',
    ssimg1: sSingleimg1,
    ssimg2: sSingleimg2,
  },
  {
    Id: '2',
    simg: simg2,
    sTitle: 'Conveyancing & Property Law',
    slug: 'Conveyancing-Property-Law',
    description:'Title transfers, mortgage registrations, property due diligence, estate transfers, and leasing agreements with panel attorney services.',
    des2:'Specialized property law services for individuals, corporates, and financial institutions.',
    des3:'Our conveyancing practice handles title transfers, mortgage registrations, due diligence, estate transfers, leasing, development agreements, and financial institution panel work.',
    icon:'flaticon-001-house',
    ssimg1: sSingleimg1,
    ssimg2: sSingleimg2,
  },
  {
    Id: '3',
    simg: simg3,
    sTitle: 'Notarial Practice',
    slug: 'Notarial-Practice',
    description:'Drafting and registration of notarial documents, trusts, long-term leases, ante-nuptial contracts, and authentication for international use.',
    des2:'Trusted notarial services for local and international documentation.',
    des3:'We prepare and register notarial deeds, authenticate documents, handle long-term leases, powers of attorney, notarial bonds, and ante-nuptial contracts.',
    icon:'flaticon-017-agreement',
    ssimg1: sSingleimg1,
    ssimg2: sSingleimg2,
  },
  {
    Id: '4',
    simg: simg4,
    sTitle: 'Litigation & Dispute Resolution',
    slug: 'Litigation-Dispute-Resolution',
    description:'Civil and commercial litigation, criminal defense, constitutional rights protection, arbitration, mediation, and enforcement matters.',
    des2:'Aggressive representation and strategic dispute resolution.',
    des3:'We handle civil/commercial litigation, criminal defence, arbitration, mediation, debt recovery, and constitutional matters with precision and force.',
    icon:'flaticon-007-gavel',
    ssimg1: sSingleimg1,
    ssimg2: sSingleimg2,
  },
  {
    Id: '5',
    simg: simg5,
    sTitle: 'Estate Planning & Administration',
    slug: 'Estate-Planning-Administration',
    description:'Wills, trusts, succession planning, deceased estates, guardianship, custody, and fiduciary advisory.',
    des2:'Compassionate and structured estate planning solutions.',
    des3:'We guide clients through wills, trusts, deceased estate administration, guardianship, custody issues, and comprehensive fiduciary advisory tailored to family needs.',
    icon:'flaticon-012-family',
    ssimg1: sSingleimg1,
    ssimg2: sSingleimg2,
  },
  {
    Id: '6',
    simg: simg6,
    sTitle: 'Mining & Investment Law',
    slug: 'Mining-Investment-Law',
    description:'Licensing, compliance, M&A, project structuring, due diligence, regulatory advisory, and community development.',
    des2:'Legal expertise for mining, resources, and investment sectors.',
    des3:'We assist mining houses and investors with licensing, regulatory compliance, M&A, project finance, due diligence, and community obligations.',
    icon:'flaticon-006-law',
    ssimg1: sSingleimg1,
    ssimg2: sSingleimg2,
  },
  {
    Id: '7',
    simg: simg7,
    sTitle: 'Data Privacy & Cyber-security',
    slug: 'Data-Privacy-Cyber-security',
    description:'Privacy audits, breach response, employee data compliance, digital forensics, and cybersecurity legal advisory.',
    des2:'Specialized cyber law and electronic security legal solutions.',
    des3:'We assist with data privacy compliance, cyber threat response, digital rights disputes, online fraud, interception breaches, and cybersecurity governance.',
    icon:'fi flaticon-013-planning',
    ssimg1: sSingleimg1,
    ssimg2: sSingleimg2,
  },
  {
    Id: '8',
    simg: simg8,
    sTitle: 'International Trade & Investment',
    slug: 'International-Trade-Investment',
    description:'Inbound investment advisory, trade negotiations, market entry, regulatory frameworks, and expropriation protection.',
    des2:'Cross-border legal support for global investors and traders.',
    des3:'We support international investors with regulatory navigation, trade agreements, compliance, expropriation risk mitigation, and structured market entry.',
    icon:'fi flaticon-014-learning',
    ssimg1: sSingleimg1,
    ssimg2: sSingleimg2,
  },
];


export default Practices;
